export const elementAtOrDefault = async (source, index) => {
    let i = 0;
    for await (const item of source) {
        if (index === i++) {
            return item;
        }
    }
    return null;
};
